import { DELETE_ADHOC_LOCATION_SUCCESS, DELETE_ADHOC_LOCATION_FAILURE } from "redux/constants/MyM"

const initState = { data: [], error: false, errorData: "", isLoading: true }

export default (state = initState, action) => {
    switch (action.type) {
        case DELETE_ADHOC_LOCATION_SUCCESS:
            return {
                ...state, data: action.payload, isLoading: false
            }
        case DELETE_ADHOC_LOCATION_FAILURE:
            return {
                ...state, errorData: action.payload, error: true, isLoading: false
            }
        default:
            return {
                ...state
            }
    }
}
